var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0.5rem"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.dataLoading
    },
    on: {
      "update:active": function($event) {
        _vm.dataLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-shipment-option"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm3('form-1')
      }
    }
  }, [_c('legend', [_vm._v(" Set Action For No-Info Shipment ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.TableDetails), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-weight": "bold"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ShowShipmentLog(item.ShippingID)
        }
      }
    }, [_vm._v(_vm._s(item.ShippingID))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.OriginHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.FinalDestinationName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.CurrentHubName) + " "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "text-muted"
    }, [_vm._v("Center type: " + _vm._s(_vm.losthubconfig.CenterType) + ", SOC: " + _vm._s(_vm.losthubconfig.SOC))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.GreaterDebitAMt))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Gst),
        expression: "item.Gst"
      }],
      attrs: {
        "id": "Gst",
        "type": "checkbox",
        "name": "Gst"
      },
      domProps: {
        "checked": Array.isArray(item.Gst) ? _vm._i(item.Gst, null) > -1 : (item.Gst)
      },
      on: {
        "change": [function($event) {
          var $$a = item.Gst,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "Gst", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "Gst", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "Gst", $$c)
          }
        }, function($event) {
          return _vm.SetPenaltyAmt(item, index)
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Penalty),
        expression: "item.Penalty"
      }],
      key: index,
      attrs: {
        "id": 'index_' + index,
        "type": "number",
        "name": "AddPenalty"
      },
      domProps: {
        "value": (item.Penalty)
      },
      on: {
        "keypress": _vm.onlyNumber,
        "change": function($event) {
          return _vm.SetPenaltyAmt(item, index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "Penalty", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      key: index,
      ref: "TotalDebitAmt",
      refInFor: true,
      attrs: {
        "id": 'index_' + index
      }
    }, [_c('label', [_vm._v(_vm._s(item.TotalDebitAmt))])])])
  }), _vm._v(" "), (_vm.TableDetails.length == 0) ? _c('tr', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "35",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [(_vm.TableDetails.length > 0) ? _c('tr', [_c('td', [_vm._v("Total Debit Amount:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "8"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.TotalSum))])]) : _vm._e()])]), _c('br')])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-shipment-option"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1",
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group custom-border1"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TotalSum),
      expression: "TotalSum"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "DebitAmount",
      "type": "text",
      "name": "DebitAmount",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.TotalSum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TotalSum = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group custom-border1"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [(_vm.IsRSC == false) ? _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.LostShipInfo.DebitFrom),
      expression: "LostShipInfo.DebitFrom"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('DebitFrom')
    },
    attrs: {
      "id": "DebitFrom",
      "name": "DebitFrom"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.LostShipInfo, "DebitFrom", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.BindDebitFrom()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Select --")]), _vm._v(" "), _vm._l((_vm.DebitFromObj), function(DebitFrom_Obj) {
    return _c('option', {
      domProps: {
        "value": DebitFrom_Obj.id
      }
    }, [_vm._v(_vm._s(DebitFrom_Obj.Debit_name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.IsRSC == true) ? _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.LostShipInfo.DebitFrom),
      expression: "LostShipInfo.DebitFrom"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('DebitFrom')
    },
    attrs: {
      "id": "DebitFrom",
      "name": "DebitFrom"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.LostShipInfo, "DebitFrom", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.BindDebitFrom()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Select --")]), _vm._v(" "), _vm._l((_vm.DebitFromObj), function(DebitFrom_Obj) {
    return _c('option', {
      domProps: {
        "value": DebitFrom_Obj.id
      }
    }, [_vm._v(_vm._s(DebitFrom_Obj.Debit_name))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.DebitFrom')),
      expression: "errors.has('form-1.DebitFrom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Debit From.")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LostShipInfo.DebitFrom == 'RSC'),
      expression: "LostShipInfo.DebitFrom == 'RSC' "
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.LostShipInfo.DebitFrom == 'RSC' ? 'required': ''))),
      expression: "`${LostShipInfo.DebitFrom == 'RSC' ? 'required': '' }`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.LostShipInfo.RSC),
      expression: "LostShipInfo.RSC"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Courier')
    },
    attrs: {
      "id": "RSC",
      "name": "RSC"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.LostShipInfo, "RSC", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Select RSC --")]), _vm._v(" "), _vm._l((_vm.RSCObj), function(RSC_Obj) {
    return _c('option', {
      style: ([RSC_Obj.isActive ? {
        'color': 'green'
      } : {
        'color': 'red'
      }]),
      attrs: {
        "onMouseOver": "red"
      },
      domProps: {
        "value": RSC_Obj.partnerId
      }
    }, [_c('span', [_vm._v("\n                            " + _vm._s(RSC_Obj.partnerName ? RSC_Obj.partnerName : '') + _vm._s(RSC_Obj.partnerName ? RSC_Obj.partnerName : '') + " | " + _vm._s(RSC_Obj.panNumber ? RSC_Obj.panNumber : '') + " |\n                            " + _vm._s(RSC_Obj.allocationDate ? RSC_Obj.allocationDate : '') + " To  " + _vm._s(RSC_Obj.deallocationDate ? RSC_Obj.deallocationDate : '') + " |\n                            " + _vm._s(RSC_Obj.isActive ? 'Active' : 'InActive') + "\n                          ")])])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.RSC')),
      expression: "errors.has('form-1.RSC')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select RSC.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "text-muted",
    staticStyle: {
      "font-size": "12px",
      "margin-left": "7px",
      "margin-bottom": "0px !important"
    }
  }, [_vm._v("Format :- Name | PAN number | Start date | End date | Status")]), _vm._v(" "), (_vm.TableDetails.length > 1) ? _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-left": "7px",
      "margin-top": "3px",
      "color": "red"
    }
  }, [_vm._v("Bulk raise debit not allowed, please select single shipment for raise debit")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.LostShipInfo.DebitFrom == 'ServiceCenter' || _vm.LostShipInfo.DebitFrom == 'RSC')),
      expression: "(LostShipInfo.DebitFrom == 'ServiceCenter' || LostShipInfo.DebitFrom == 'RSC' )"
    }]
  }, [(!_vm.isLostNewFeaturesisOnThisHub) ? _c('div', {
    staticClass: "form-group custom-border1"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('b-input-group', {
    class: _vm.DebitUserSelectedOptions.length < 3 ? 'col-md-4' : 'col-md-7',
    attrs: {
      "left": "<i class='fa  fa-user'></i>",
      "right": _vm.debitCatLoader
    }
  }, [_c('Multiselect', {
    class: {
      'error': _vm.errors.has('DebitUserSelectedOptions')
    },
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.users,
      "custom-label": _vm.customBConfigLabel,
      "track-by": "EmpTypeName",
      "hide-selected": true,
      "multiple": true
    },
    on: {
      "select": _vm.userObj,
      "input": _vm.changeloadEmployess
    },
    model: {
      value: (_vm.DebitUserSelectedOptions),
      callback: function($$v) {
        _vm.DebitUserSelectedOptions = $$v
      },
      expression: "DebitUserSelectedOptions"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAlluser),
      expression: "selectAlluser"
    }],
    attrs: {
      "type": "checkbox",
      "name": "selectAlluser",
      "id": "selectAlluser"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAlluser) ? _vm._i(_vm.selectAlluser, null) > -1 : (_vm.selectAlluser)
    },
    on: {
      "click": function($event) {
        return _vm.selectAll($event)
      },
      "change": function($event) {
        var $$a = _vm.selectAlluser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAlluser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAlluser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAlluser = $$c
        }
      }
    }
  }), _vm._v(" Select All Debit Users.\n\n                       ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "form-group custom-border1"
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "margin-bottom": "10px"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("\n                        Total Record: " + _vm._s(_vm.filteredEmployees.length) + "\n                        "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n                          Total Selected: " + _vm._s(_vm.selectedItems.length) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-left": "0px",
      "padding-bottom": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "DebitConserPerson",
      "type": "text",
      "name": "DebitConserPerson",
      "placeholder": "Search Debit concern"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDebitPersonSelected),
      expression: "isDebitPersonSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.LostShipInfo.DebitFrom == 'ServiceCenter' ? 'required': ''))),
      expression: "`${LostShipInfo.DebitFrom == 'ServiceCenter' ? 'required': '' }`"
    }],
    class: {
      'error': _vm.errors.has('personSelected')
    },
    attrs: {
      "type": "hidden",
      "name": "personSelected",
      "id": "personSelected"
    },
    domProps: {
      "value": (_vm.isDebitPersonSelected)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isDebitPersonSelected = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.personSelected')),
      expression: "errors.has('form-1.personSelected')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Debit Person.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group custom-border1 table",
    staticStyle: {
      "height": "180px",
      "overflow-x": "auto",
      "margin": "5px 0px 20px 0px"
    }
  }, [_c('div', {
    staticClass: "input-group table-area"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isDebitPersonLoading,
      "text": "Please wait debit persons list is being loading.."
    },
    on: {
      "update:active": function($event) {
        _vm.isDebitPersonLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "debit",
    staticStyle: {
      "border": "1px solid #ccc",
      "table-layout": "fixed"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticStyle: {
      "color": "Black",
      "background-color": "#D1ECFD",
      "font-weight": "bold",
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Debit Person")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Emp ID")]), _vm._v(" "), (!_vm.isLostNewFeaturesisOnThisHub) ? _c('th', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("Type")]) : _vm._e(), _vm._v(" "), (_vm.isLostNewFeaturesisOnThisHub) ? _c('th', {
    staticStyle: {
      "width": "15%",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleSortByType
    }
  }, [_vm._v("\n                              Type\n                              "), _c('span', [_vm._v(_vm._s(_vm.sortByTypeAsc ? '▲' : '▼'))])]) : _vm._e(), _vm._v(" "), (_vm.isLostNewFeaturesisOnThisHub) ? _c('th', {
    staticStyle: {
      "width": "9%",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleSortByVertical
    }
  }, [_vm._v("\n                              Vertical\n                              "), _c('span', [_vm._v(_vm._s(_vm.sortByVerticalAsc ? '▲' : '▼'))])]) : _vm._e(), _vm._v(" "), _c('th', {
    style: ({
      width: _vm.isLostNewFeaturesisOnThisHub ? '15%' : '20%'
    })
  }, [_vm._v("Debit Share in Rs.")]), _vm._v(" "), _c('th', {
    style: ({
      width: _vm.isLostNewFeaturesisOnThisHub ? '12%' : '15%'
    })
  }, [_vm._v("Percentage")])])]), _vm._v(" "), _c('tbody', [(_vm.filteredEmployees.length > 0) ? _vm._l((_vm.filteredEmployees), function(i) {
    return _c('tr', {
      key: ("" + (i[_vm.keyName]) + (i[_vm.keyUserId]))
    }, [_c('td', {
      staticStyle: {
        "width": "3%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItems),
        expression: "selectedItems"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("" + (i[_vm.keyName]) + (i[_vm.keyUserId]))
      },
      domProps: {
        "value": ("" + (i[_vm.keyName]) + (i[_vm.keyUserId])),
        "checked": Array.isArray(_vm.selectedItems) ? _vm._i(_vm.selectedItems, ("" + (i[_vm.keyName]) + (i[_vm.keyUserId]))) > -1 : (_vm.selectedItems)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "" + (i[_vm.keyName]) + (i[_vm.keyUserId]),
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItems = $$c
          }
        }, function($event) {
          return _vm.calculateDebitAmout(("" + _vm.TotalSum), 100, ("" + (i[_vm.keyName]) + (i[_vm.keyUserId])))
        }]
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(i.username) + " "), (i.EmpTypeName != null) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(i.EmployeeID))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(i.EmpTypeName))]), _vm._v(" "), (_vm.isLostNewFeaturesisOnThisHub) ? _c('td', {
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(i.Vertical))]) : _vm._e(), _vm._v(" "), _c('td', {
      style: ({
        width: _vm.isLostNewFeaturesisOnThisHub ? '13%' : '20%'
      })
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (_vm.debitPersonAmount[("" + (i[_vm.keyName]) + (i[_vm.keyUserId]))]),
        expression: "debitPersonAmount[`${i[keyName]}${i[keyUserId]}`]",
        modifiers: {
          "lazy": true
        }
      }],
      class: _vm.danger,
      staticStyle: {
        "width": "100%",
        "max-width": "80px",
        "box-sizing": "border-box"
      },
      attrs: {
        "type": "text",
        "id": ("debitshare" + (i[_vm.keyName]) + (i[_vm.keyUserId])),
        "name": "debitshare"
      },
      domProps: {
        "value": (_vm.debitPersonAmount[("" + (i[_vm.keyName]) + (i[_vm.keyUserId]))])
      },
      on: {
        "keypress": _vm.onlyNumber,
        "change": [function($event) {
          return _vm.$set(_vm.debitPersonAmount, ("" + (i[_vm.keyName]) + (i[_vm.keyUserId])), $event.target.value)
        }, function($event) {
          return _vm.adjustDebitPercenatge(("" + (i[_vm.keyName]) + (i[_vm.keyUserId])))
        }]
      }
    })]), _vm._v(" "), _c('td', {
      style: ({
        width: _vm.isLostNewFeaturesisOnThisHub ? '13%' : '15%'
      })
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (_vm.debitPersonPercent[("" + (i[_vm.keyName]) + (i[_vm.keyUserId]))]),
        expression: "debitPersonPercent[`${i[keyName]}${i[keyUserId]}`]",
        modifiers: {
          "lazy": true
        }
      }],
      class: _vm.danger,
      staticStyle: {
        "width": "100%",
        "max-width": "80px",
        "box-sizing": "border-box"
      },
      attrs: {
        "type": "text",
        "name": "percentage",
        "id": ("percentage" + (i[_vm.keyName]) + (i[_vm.keyUserId]))
      },
      domProps: {
        "value": (_vm.debitPersonPercent[("" + (i[_vm.keyName]) + (i[_vm.keyUserId]))])
      },
      on: {
        "keypress": _vm.onlyNumber,
        "change": [function($event) {
          return _vm.$set(_vm.debitPersonPercent, ("" + (i[_vm.keyName]) + (i[_vm.keyUserId])), $event.target.value)
        }, function($event) {
          return _vm.adjustDebitAmout(("" + (i[_vm.keyName]) + (i[_vm.keyUserId])))
        }]
      }
    }), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "olduserid",
        "id": ("olduserid" + (i[_vm.keyName]) + (i[_vm.keyUserId]))
      },
      domProps: {
        "value": i.OldDeliveryUserOrUserId
      }
    })])])
  }) : _vm._e()], 2)])], 1)])]), _vm._v(" "), (_vm.adjustDebitAmount != 0) ? _c('div', {
    staticClass: "form-group custom-border1"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.adjustDebitAmount))])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('adjustDebitAmount')
    },
    attrs: {
      "type": "checkbox",
      "name": "adjustDebitAmount",
      "id": "adjustDebitAmount"
    }
  }), _vm._v("  Balance to be adjusted ")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.adjustDebitAmount')),
      expression: "errors.has('form-1.adjustDebitAmount')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please check to adjust debit amount.")])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountExceedError),
      expression: "amountExceedError"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Balance to be Adjust amount should be less than zero, Please adjust amount.!")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LostShipInfo.DebitFrom == 'Courier'),
      expression: "LostShipInfo.DebitFrom == 'Courier'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.LostShipInfo.DebitFrom == 'Courier' ? 'required': ''))),
      expression: "`${LostShipInfo.DebitFrom == 'Courier' ? 'required': '' }`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.LostShipInfo.Courier),
      expression: "LostShipInfo.Courier"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Courier')
    },
    attrs: {
      "id": "Courier",
      "name": "Courier"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.LostShipInfo, "Courier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Select Courier --")]), _vm._v(" "), _vm._l((_vm.CourierObj), function(Courier_Obj) {
    return _c('option', {
      domProps: {
        "value": Courier_Obj.id
      }
    }, [_vm._v(_vm._s(Courier_Obj.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Courier')),
      expression: "errors.has('form-1.Courier')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Courier.")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LostShipInfo.DebitFrom == 'Coloader'),
      expression: "LostShipInfo.DebitFrom == 'Coloader'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.LostShipInfo.DebitFrom == 'Coloader' ? 'required': ''))),
      expression: "`${LostShipInfo.DebitFrom == 'Coloader' ? 'required': '' }`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.LostShipInfo.Coloader),
      expression: "LostShipInfo.Coloader"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Coloader')
    },
    attrs: {
      "id": "Coloader",
      "name": "Coloader"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.LostShipInfo, "Coloader", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select coloader --")]), _vm._v(" "), _vm._l((_vm.ColoaderObj), function(Coloader_Obj) {
    return _c('option', {
      domProps: {
        "value": Coloader_Obj.Id
      }
    }, [_vm._v(_vm._s(Coloader_Obj.Name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Coloader')),
      expression: "errors.has('form-1.Coloader')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Coloader.")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LostShipInfo.DebitFrom == 'Vendor' || _vm.LostShipInfo.DebitFrom == 'NetworkVendor'),
      expression: "LostShipInfo.DebitFrom == 'Vendor' || LostShipInfo.DebitFrom == 'NetworkVendor'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.LostShipInfo.DebitFrom == 'Vendor' || _vm.LostShipInfo.DebitFrom == 'NetworkVendor' ? 'required': ''))),
      expression: "`${LostShipInfo.DebitFrom == 'Vendor' || LostShipInfo.DebitFrom == 'NetworkVendor' ? 'required': '' }`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.LostShipInfo.Vendor),
      expression: "LostShipInfo.Vendor"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Vendor')
    },
    attrs: {
      "id": "Vendor",
      "name": "Vendor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.LostShipInfo, "Vendor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select Vendor --")]), _vm._v(" "), _vm._l((_vm.VendorObj), function(Vendor_Obj) {
    return _c('option', {
      domProps: {
        "value": Vendor_Obj.Id
      }
    }, [_vm._v(_vm._s(Vendor_Obj.Name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Vendor')),
      expression: "errors.has('form-1.Vendor')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Vendor.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "d-flex col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "margin-right": "5px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.comments),
      expression: "comments",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "4",
      "name": "comments",
      "id": "comments",
      "maxlength": _vm.max
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "change": function($event) {
        _vm.comments = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "textarea-style text-muted small",
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("\n                         Maximum length 500/" + _vm._s((_vm.max - _vm.comments.length)) + " Characters.\n                       ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "gap": "8px",
      "margin-top": "2%"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.validated ? false : true
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Raise Debit Request\n                       ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    on: {
      "click": _vm.clear
    }
  }), _vm._v("Reset")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.comments')),
      expression: "errors.has('form-1.comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter Comments.")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSaveLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSaveLoading = $event
      }
    }
  })], 1)])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.shipmentlogmodal = false
      }
    },
    model: {
      value: (_vm.shipmentlogmodal),
      callback: function($$v) {
        _vm.shipmentlogmodal = $$v
      },
      expression: "shipmentlogmodal"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Shipment Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShipmentLogModal
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("BagNo")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ProcessLocation")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Process")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comment")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedDate")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedBy")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentLog), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProcessLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedBy))])])
  }), 0)])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.modelValue),
      callback: function($$v) {
        _vm.modelValue = $$v
      },
      expression: "modelValue"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title1"
  }, [_vm._v("Mark Lost and Raise Debit Status")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Message")])])]), _vm._v(" "), _c('tbody', [(_vm.apiResponseforTable.length > 0) ? _vm._l((_vm.apiResponseforTable), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      style: (row.code == 200 ? _vm.styleObjectSuccess : _vm.styleObjectFailure),
      attrs: {
        "width": "60%"
      }
    }, [_vm._v(_vm._s(row.ShippindIds.replaceAll(',', '\n')))]), _vm._v(" "), _c('td', {
      style: (row.code == 200 ? _vm.styleObjectSuccess : _vm.styleObjectFailure)
    }, [_vm._v(_vm._s(row.message))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm mt-4",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel()
      }
    }
  }, [_vm._v("Close")])])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current Hub")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Debit Amount")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("GST Included")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Add Penalty")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total Debit Amount")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Debit Amount : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Debit From : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" RSC : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Debit User Category : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Debit Adjust Amount :")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Courier : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Coloader : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Vendor : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Comments :")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89ee79fa","hasScoped":true}!./src/views/components/LOST/HubMarkLostDebit/HubMarkLostDebit.component.html
// module id = 1088
// module chunks = 1